import { createSelector } from "@reduxjs/toolkit"
import type { CanvasI } from "tweenly"
import { AppStateT } from "../store/store"

export const selectUndoable = (state: AppStateT) => state.undoable.present
export const selectCanUndo = (state: AppStateT) => state.undoable.past.length > 0
export const selectCanRedo = (state: AppStateT) => state.undoable.future.length > 0

/**
 * Canvas with the resolution from the editor settings applied.
 *
 * Memoized on purpose: the previous inline version built a fresh object in every consumer,
 * and `useObjectActions` (instantiated once per canvas object) pulled it in through
 * `useCanvas` just to read width/height inside one handler.
 */
export const selectCanvasResolution = createSelector(
    [
        (state: AppStateT) => state.canvas.value!,
        (state: AppStateT) => state.editor.value.settings.canvasResolution,
    ],
    (canvas, canvasResolution): CanvasI => ({
        ...canvas,
        width: canvasResolution[0],
        height: canvasResolution[1],
    })
)

export const selectCompanyId = (state: AppStateT): string =>
    state.graphic.data.companyId || state.editor.value.settings.companyId!
